export class Staff {
  constructor(http) {
    this.http = http;
  }

  fetch( page = 1, search = '', filter = undefined, filters = []) {

    let params = { page, page_size: 15, search: search || undefined, filter: filter || undefined };

    filters.forEach(filter => {
      params[filter.type] = filter.value;
    });

    return this.http.get('staff/', { params }).then(response => response.data);
  }

  fetchGroups() {
    return this.http.get('groups/').then(response => response.data);
  }

  fetchStaffById(id) {
    return this.http.get(`staff/${id}`).then(response => response.data);
  }

  createStaff(data) {
    return this.http.post(`staff/`, data).then(response => response.data);
  }

  updateStaff(data) {
    return this.http.post(`staff/${data.id}/`, data).then(response => response.data);
  }
}
